import React, { useEffect, useState } from 'react';
import { readHealthCommission } from './fontStyle';

// Health commission logo + registration no. from Template Settings, shown
// below the doctor info at the bottom right of every report.
// Renders nothing when neither is configured.
const HealthCommission = ({ fontFamily }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(readHealthCommission());
  }, []);

  if (!data) return null;

  return (
    <div
      className="report-health-commission"
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        // Pull the block in from the right edge, a little towards the center.
        paddingRight: '48px',
        margin: '4px 0 8px',
        fontFamily,
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      }}
    >
      {/* Reg. No on top, logo centered below it */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '2px' }}>
        {data.registrationNo && (
          <div style={{ fontSize: '10px', color: '#0f172a' }}>
            <span style={{ fontWeight: 600 }}>Reg.No:</span> {data.registrationNo}
          </div>
        )}
        {data.logo && (
          <img
            src={`data:${data.logoContentType || 'image/png'};base64,${data.logo}`}
            alt="Health Commission"
            style={{ maxHeight: '50px', maxWidth: '140px', objectFit: 'contain' }}
          />
        )}
      </div>
    </div>
  );
};

export default HealthCommission;
